import { Component } from '@angular/core';

@Component({
	selector: 'app-public',
	templateUrl: './public.component.html',
	styleUrls: ['./public.component.css'],
	standalone: false,
})
export class PublicComponent {
	constructor() {}
}
